const translates: { [key: string]: { id: string } } = {
  inputsLogic: { id: 'inputs_logic' },
  newLogicBlock: { id: 'new_logic_block' },
  ifCondition: { id: 'if' },
  conditionText: { id: 'condition_text' },
  all: { id: 'all' },
  one: { id: 'one' },
  input: { id: 'input' },
  value: { id: 'value' },
  is: { id: 'is' },
  is_not: { id: 'is_not' },
  lt: { id: 'lt' },
  lte: { id: 'lte' },
  gt: { id: 'gt' },
  gte: { id: 'gte' },
  eq: { id: 'eq' },
  neq: { id: 'neq' },
  then: { id: 'then' },
  logicalBlock: { id: 'logical_block' },
  chooseInput: { id: 'choose_input' },
  chooseValue: { id: 'choose_value' },
  addCondition: { id: 'add_condition' },
  addPopulate: { id: 'add_populate' },
  show: { id: 'show' },
  populate: { id: 'populate' },
  populateLogicBlock: { id: 'populate_logic_block' },
  newPopulateBlock: { id: 'new_populate_block' },
  populateIfText: { id: 'populate_if_text' },
  populateThenText: { id: 'populate_then_text' },
  yes: { id: 'yes' },
  no: { id: 'no' },
  save: { id: 'save' },
  cancel: { id: 'cancel' },
}

export default translates
